<template>
  <page>
    <el-alert
      v-if="externalSegmentNamesUnavailable"
      type="warning"
      :closable="false"
      show-icon
      :title="
        $t(
          'Audiences_RollingSegment_Destination_External_Segment_Names_Warning'
        )
      "
      style="margin-bottom: 16px"
    />
    <rest-list :payload="fetchEndpoint" @dataLoaded="onDestinationsLoaded">
      <rest-list-column
        :title="$t('Audiences_RollingSegment_Destination_Name')"
        prop="integration.name"
      />
      <rest-list-column
        :title="$t('Audiences_RollingSegment_Destination_Title')"
        prop="integration.params.destination_url"
      />
      <rest-list-column
        :title="$t('Audiences_RollingSegment_Destination_External_Segment_Id')"
        prop="external_segment_id"
        :sortable="false"
        :filterable="false"
      >
        <template slot-scope="scope">
          {{ externalSegmentDisplayValue(scope.row) }}
          <i
            v-if="
              isExternalSegmentsLoading(scope.row.webhook_stream_integration_id)
            "
            class="el-icon-loading"
          />
        </template>
      </rest-list-column>
      <rest-list-column-actions v-if="$can('Segment::Update')">
        <template slot-scope="scope">
          <rest-list-action
            icon="el-icon-refresh"
            :title="$t('Audiences_RollingSegment_Destination_Full_Sync')"
            :click="showSyncDialog"
            :row="scope.row"
            data-qa="full-sync"
          />
        </template>
      </rest-list-column-actions>
    </rest-list>
    <full-sync-dialog
      @close="closeSyncDialog"
      v-if="showFullSyncDialog"
      :destination="syncDestination"
    />
  </page>
</template>

<script>
import Page from '@/common/components/page/Page.vue'
import RestList from '@/common/components/rest/RestList'
import { projectEndpoint } from '@/core/helpers'
import RestListColumn from '@/common/components/rest/RestListColumn.vue'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListAction from '@/common/components/rest/RestListAction'
import FullSyncDialog from '@/modules/audiences/components/FullSyncDialog'
import externalSegmentsMixin from '@/modules/audiences/mixins/externalSegmentsMixin'

export default {
  name: 'RollingSegmentTabDestinations',
  mixins: [externalSegmentsMixin],
  components: {
    RestListColumn,
    RestList,
    Page,
    RestListColumnActions,
    RestListAction,
    FullSyncDialog
  },
  data() {
    return {
      syncDestination: null,
      showFullSyncDialog: false
    }
  },
  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `rolling-segment-destination`,
        params: {
          rolling_segment_id: this.$route.query.id,
          expand: 'integration'
        }
      })
    },
    externalSegmentNamesUnavailable() {
      return Object.values(this.externalSegmentsByIntegration).some(
        entry => entry.status === 'failed'
      )
    }
  },
  methods: {
    showSyncDialog(destination) {
      this.syncDestination = destination
      this.showFullSyncDialog = true
    },
    closeSyncDialog() {
      this.syncDestination = null
      this.showFullSyncDialog = false
    },
    onDestinationsLoaded(rows) {
      const integrationIds = (rows || []).map(
        row => row.webhook_stream_integration_id
      )
      this.ensureExternalSegmentsLoaded(integrationIds)
    },
    externalSegmentDisplayValue(row) {
      const name = this.findExternalSegmentName(
        row.webhook_stream_integration_id,
        row.external_segment_id
      )
      return name
        ? `${name} (${row.external_segment_id})`
        : row.external_segment_id
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/pages/RollingSegmentTabDestinations.vue